export const SCAN_STATUSES = Object.freeze({
    READY: 'Готов к сканированию',
    SCANNING: 'Сканирование...',
    NUMBER_FOUND: 'Номер найден',
    NUMBER_NOT_FOUND: 'Номер не найден',
    ERROR: 'Ошибка сканирования',
    CAMERA_ERROR: 'Ошибка доступа к камере',
    LOGIN_FAILED: 'Не удалось войти. Попробуйте снова',
    PHOTO_NOT_RECOGNIZED: 'Код не распознан, снимите ещё раз',
});

// Текст под сканером: сотрудник должен понимать, что делать дальше,
// а не гадать над технической ошибкой
export const SCAN_ERRORS = Object.freeze({
    NOT_RECOGNIZED: 'Штрих-код не распознан. Снимите ещё раз: держите карточку'
        + ' крупно, чтобы штрих-код занимал большую часть кадра.',
    WRONG_FORMAT: 'Это не похоже на код сотрудника. Убедитесь, что снимаете'
        + ' штрих-код с рабочей карточки.',
    PHOTO_FAILED: 'Не удалось обработать снимок. Попробуйте сфотографировать ещё раз.',
});
